export default function auth ({ next, store  }){
    if(!store.state.user.user.data.verifyOndatoAt){
        return next({
            name: 'user.setting.creator'
        })
    }
    return next()
}
